import gql from 'graphql-tag'

export const serviceOrderDelete = gql`
  mutation serviceOrderDelete($serviceOrderId: ID!) {
    serviceOrderDelete(input: { serviceOrderId: $serviceOrderId }) {
      success
    }
  }
`
